module.exports = __webpack_public_path__ + "daa49c16dba2bc5f54911e68d2983174.svg";